import { ActivityTaskViewCommandForm } from './forms/ActivityTaskViewCommandForm';
import { hasActivityTaskId } from '@ayocore/activity/common/types/activity-command-context';
import { registerActivityChatCommand } from '@ayocore/activity/client/extensions';

/**
 * Surface `task_view` — просмотр задачи в `ActivityContextView`.
 */
export const taskViewActivityChatCommand = registerActivityChatCommand({
  id: 'task_view',
  trigger: 'task-view',
  label: 'Просмотр задачи',
  description: 'Показать детали задачи в контексте чата',
  isAvailable: context => context.source === 'pin' && hasActivityTaskId(context.payload),
  FormComponent: ActivityTaskViewCommandForm,
});
